'use strict';

import { graphql } from 'react-relay/legacy';

export const sbRespDesignsRoot = graphql`
    query sbRespDesignsRootQuery(
        $userId: String = ""
        $personalizationId: String = ""
        $guestId: String = ""
        $rerankUserId: String = ""
        $rerankGuestId: String = ""
        $fetchUser: Boolean!
        $uriRef: String = ""
        $originalUrl: String = ""
        $first: Int!
        $page: Int!
        $localeOrigin: String = ""
        $isTrade: Boolean!
        $showSeller: Boolean!
        $followSearchPages: [String]
        $followSearchTypes: [types] = [SEARCH, USER_PREFERENCE]
        $contentModuleId: String = ""
        $regions: String = ""
        $userZipCode: String = ""
        $userCountryCode: String = ""
        $fetchRegionalInfo: Boolean = false
        $isClient: Boolean!
        $fetchSb: Boolean!
        $disableForceFacet: Boolean = false
        $disableNonParameterizedUrlRedirects: Boolean = false # Only used for static SB
        $fetchTileVideo: Boolean = false
        $priceBookName: String
        $regionsList: [String]
        $includeSponsoredItems: Boolean = false
        $pageDisplayEnum: PageDisplayEnum = searchAndBrowse
        $numOfItemsToInflate: Int
    ) {
        viewer {
            ...SbRespDesignsLayout_viewer
            ...detectPageExistsAndRedirect_viewer
        }
    }
`;
